import { Button, Stack } from "@mui/material";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_SECONDARY,
  COLOR_VERY_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import { ReactElement } from "react";
import React from "react";
import { CustomTextView } from "../../component/CustomTextView";
import { useLocation, useNavigate } from "react-router-dom";

export interface DrawerItem {
  isRoute: boolean;
  title: string;
  icon: ReactElement;
  onClick?: () => void;
  isSelected?: boolean;
  href?: string;
  onCloseDrawer?: () => void;
}

export function DrawerItemView(props: DrawerItem) {
  const navigate = useNavigate();
  const location = useLocation();

  const bgColor = props.isSelected ? COLOR_MAIN : undefined;
  return (
    <Button
      key={props.title}
      sx={{
        background: bgColor,
        paddingTop: props.isRoute ? 2 : 1,
        paddingBottom: props.isRoute ? 2 : 1,
        paddingLeft: 2,
        paddingRight: 2,
        marginLeft: 2,
        marginRight: 2,
        borderRadius: props.isRoute ? 3 : 12,
        border: props.isRoute ? undefined : "1px solid gray",
        "&:hover": {
          backgroundColor: "lightGray",
          "@media (hover: none)": {
            backgroundColor: bgColor,
          },
        },
        "& .MuiTouchRipple-child": {
          backgroundColor: COLOR_LESS_BLACK,
        },
      }}
      onClick={
        props.isRoute
          ? () => {
              if (location.pathname === props.href) return;
              window.scrollTo(0, 0);
              navigate(props.href!);
              setTimeout(() => {
                if (props.onCloseDrawer != undefined) props.onCloseDrawer();
              }, 300);
            }
          : props.onClick
      }
      LinkComponent={"a"}
    >
      <Stack
        direction={"row"}
        spacing={props.isRoute ? 1.5 : 1}
        justifyContent={props.isRoute ? "start" : "center"}
        display={"flex"}
        flex={1}
      >
        {React.Children.map(props.icon, (child) => {
          return React.cloneElement(
            child as React.ReactElement<{ sx?: object }>,
            {
              sx: {
                color: props.isSelected ? COLOR_WHITE : COLOR_LIGHT_GRAY,
              },
            }
          );
        })}
        <CustomTextView
          text={props.title}
          textColor={props.isSelected ? COLOR_WHITE : COLOR_LIGHT_GRAY}
          props={{ textTransform: "none" }}
          fontWeight={props.isSelected ? "bold" : "normal"}
        />
      </Stack>
    </Button>
  );
}
